import { render, staticRenderFns } from "./InputSettings.vue?vue&type=template&id=6f83a4f5&"
import script from "./InputSettings.vue?vue&type=script&lang=js&"
export * from "./InputSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports